import React, { useState, useEffect, useRef } from "react";
import "./LicenseDetails.scss";
import axios from "axios";
import { Route, Navigate ,useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
function LicenseDetails() {

  const [licenseDetails, setLicenseDetails] = useState(null);
  const navigate = useNavigate();
  const { te_lmsid } = useParams();
  console.log(te_lmsid)


useEffect(() => {

  const fetchLicenseDetails = async () => {
    try {
      const response = await axios.get('/v1/licensedetails/listbyid/'+te_lmsid,
      {
        headers: {
          'Authorization': 'Bearer'+' '+sessionStorage.getItem("access_token"),
        }});
      if (response.status === 200) {
        setLicenseDetails(response.data.data);
        // console.log("licenseDetails",licenseDetails.order_details[0].te_ordernumber)
      } else {
        console.error("Failed to fetch license details");
      }
    } catch (error) {
      console.error("Error fetching license details:", error);
    }
  };

  fetchLicenseDetails();
}, [te_lmsid]);

const formatDate = (dateString) => {
  if (!dateString) {
    return "";
  }

  const date = moment.utc(dateString).format('DD-MMM-YYYY');

  if (date === "Invalid date") {
    return "";
  }

  return date;
};

const calculateValidDays = () => {
  if (!licenseDetails || !licenseDetails.te_licenseactivationdate || !licenseDetails.te_licenseexpirationdate) {
    return "";
  }
  const activationDate = moment.utc(licenseDetails.te_licenseactivationdate);
  const expirationDate = moment.utc(licenseDetails.te_licenseexpirationdate);
  const validDays = expirationDate.diff(activationDate, 'days')+1;
  return validDays;
};

  return (
    <div className="LicenseDetails">
        <div className="License-details">
                    
                     <div >
                     <div className="d-flex mb-2">
                       <h5 style={{ marginRight: "auto", fontSize:"35px" }}>License Details</h5>
                     </div>
                     <div className="License-table">
                       <div className="heading">License Details</div>
                       <div className="License-design" style={{height:"calc(58vh - 50px)"}} >
                       <table className="table-data">
                         <thead className="License-table-head">
                           <tr>
                             <th>Ord No</th>
                             <th>License No</th>
                             <th>License Key</th>
                             <th>License Code</th>
                             <th>Valid Days</th>
                             <th>No of User License</th>
                             <th>Issue Date</th>
                             <th>Expiry Date</th>
                             <th>Authenticated to extend</th>
                             <th>Reason to extend</th>
                             <th>Status</th>
                             <th>Company Details</th>
                             <th>Payment Details</th>
                           </tr>
                         </thead>
                         <tbody className="License-table-body">
  {licenseDetails ? (
    licenseDetails.order_details && licenseDetails.order_details.length > 0 ? (
      <tr>
        <td>{licenseDetails.order_details[0].te_ordernumber || "N/A"}</td>
        <td>{licenseDetails.te_licenseno || "N/A"}</td>
        <td>{licenseDetails.te_lmsid || "N/A"}</td>
        <td>{licenseDetails.te_licensecode || "N/A"}</td>
        <td>{calculateValidDays() || "N/A"}</td>
        <td>{licenseDetails.te_licenseusedbyusers || "N/A"}</td>
        <td>{formatDate(licenseDetails.te_licenseactivationdate) || "N/A"}</td>
        <td>{formatDate(licenseDetails.te_licenseexpirationdate) || "N/A"}</td>
        <td>{licenseDetails.te_islicenseactivated ? 'Yes' : 'No' || "N/A"}</td>
        <td>{licenseDetails.te_extendlicencedescription || "N/A"}</td>
        <td>{licenseDetails.te_islicenseactivated ? 'Active' : 'Inactive' || "N/A"}</td>
        <td style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => {
          navigate(`/CompanyDetails/${licenseDetails.te_companyid}/${te_lmsid}`);
        }}>{licenseDetails.master_company.te_companyname}</td>
        <td style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => {
          navigate(`/CompanyDetails/${licenseDetails.te_companyid}/${te_lmsid}`)
        }}>Cheque</td>
      </tr>
    ) : (
      <div>
        <div style={{color:"red", textAlign:"center"}} colSpan="13">Order not found for this Licence</div>
      </div>
    )
  ) : (
    <div>
        <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", margin: "100px" }}>
                          <CircularProgress color="inherit" />
                        </Box>
    </div>
  )}
</tbody>
                         {/* <tbody className="License-table-body">
                         
                     
                         {licenseDetails && licenseDetails.order_details && licenseDetails.order_details.length > 0 && ( 
                <tr>
                  <td>{licenseDetails.order_details[0].te_ordernumber  ? licenseDetails.order_details[0].te_ordernumber  : "N/A"}</td>
              
                  <td>{licenseDetails.te_licenseno}</td>
                  <td>{licenseDetails.te_lmsid}</td>
                  <td>{licenseDetails.te_licensecode}</td>
              
                  <td>{calculateValidDays()}</td>
                  <td>{licenseDetails.te_licenseusedbyusers}</td>
                  <td>{formatDate(licenseDetails.te_licenseactivationdate)}</td>
                  <td>{formatDate(licenseDetails.te_licenseexpirationdate)}</td>
                  <td>{licenseDetails.te_islicenseactivated ? 'Yes' : 'No'}</td>
                  <td>{licenseDetails.te_extendlicencedescription}</td>
                  <td>{licenseDetails.te_islicenseactivated ? 'Active' : 'Inactive'}</td>
               
                     <td style={{ textDecoration: "underline",cursor:"pointer" }} onClick={() => {
                        navigate(`/CompanyDetails/${licenseDetails.te_companyid}/${te_lmsid}`);
                      }}>{licenseDetails.master_company.te_companyname}</td>  
                  <td style={{ textDecoration: "underline",cursor:"pointer" }} onClick={() => { 
                      navigate(`/CompanyDetails/${licenseDetails.te_companyid}/${te_lmsid}`) }}>Cheque</td>
                </tr>
              )}
                         </tbody> */}
                       </table></div>
                       </div>
                     </div>
                   </div>
    </div>
  )
}

export default LicenseDetails